import React from 'react';
import { Card, Typography } from 'antd';
import { SEMANTIC, CARD_SHADOW, Severity } from '../../theme/statusColors.ts';

const { Text } = Typography;

interface AlertCardProps {
  title: string;
  count: number;
  severity: Severity;
  icon: React.ReactNode;
  subText?: string;
  onClick: () => void;
}

// Card di alert cliccabile: bordo sinistro colorato per severità,
// icona in cerchio tinta, count grande. Count 0 => verde "Nessuna azione".
const AlertCard: React.FC<AlertCardProps> = ({ title, count, severity, icon, subText, onClick }) => {
  const effectiveSeverity: Severity = count === 0 ? 'success' : severity;
  const color = SEMANTIC[effectiveSeverity];

  return (
    <Card
      hoverable
      size="small"
      onClick={onClick}
      style={{
        borderLeft: `4px solid ${color}`,
        boxShadow: CARD_SHADOW,
        height: '100%',
      }}
      styles={{ body: { padding: '12px 16px' } }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: `${color}1A`,
            color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            flexShrink: 0,
          }}
        >
          {icon}
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 26, fontWeight: 600, lineHeight: 1.1, color }}>
            {count}
          </div>
          <Text style={{ fontSize: 12, display: 'block' }} ellipsis={{ tooltip: title }}>
            {title}
          </Text>
          <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>
            {count === 0 ? 'Nessuna azione richiesta' : subText || ' '}
          </Text>
        </div>
      </div>
    </Card>
  );
};

export default AlertCard;
